import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {CustomerProfileState} from '../../+state/stores.reducer';
import {getCustomerProfileState} from '../../+state/stores.selectors';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrl: './profile-picture.component.scss',
})
export class ProfilePictureComponent implements OnInit {
  customerProfileState: CustomerProfileState;
  profilePicture = '';

  constructor(private store: Store<any>) {
  }

  ngOnInit() {
    this.store.select(getCustomerProfileState).subscribe((state: CustomerProfileState) => {
      this.customerProfileState = state;
      this.profilePicture = state?.data?.profilePicture || '';
      if (this.profilePicture && state?.profilePictureSalt) {
        this.profilePicture = `${this.profilePicture}?salt=${state.profilePictureSalt}`;
      }
    });
  }

}
